import { createClient } from "@/utils/supabase/client";

const supabase = createClient();

export function getAvatarUrl(
  avatarUrl: string | null | undefined,
): string | undefined {
  if (!avatarUrl) return undefined;

  if (avatarUrl.startsWith("http")) {
    return avatarUrl;
  }

  return supabase.storage.from("avatars").getPublicUrl(avatarUrl).data
    .publicUrl;
}
